import React, { useContext } from "react";
import "./Works.css";
// import Upwork from "../../img/Upwork.png";
// import Fiverr from "../../img/fiverr.png";
// import Amazon from "../../img/amazon.png";
// import Shopify from "../../img/Shopify.png";
import nodejs from  "../../img/node-js-seeklogo.png"
import react from "../../img/react-seeklogo.png"
import mongodb from "../../img/mongodb-seeklogo.png"
import vite from "../../img/vite-seeklogo.png"
import sql  from "../../img/azure-sql-seeklogo.png"
import firebase from "../../img/firebase-icon-seeklogo.png"
import next from "../../img/next-js-seeklogo.png"
import express from "../../img/express-seeklogo.png"
import javascript from "../../img/javascript-seeklogo.png"
import prisma from "../../img/prisma-seeklogo.png"
// import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
            Technical skills
          </span>
          <span>Languages & Frameworks</span>
          <spane>
          I adapt to modern technologies such as the MERN stack (MongoDB, Express, React, Node) alongside CSS, JavaScript, and HTML
            <br />
             My expertise in both front and back-end development enables me to enhance application performance through the active implementation of secure access control, 
            efficient API and service connectivity, as well as other maintenance procedures
            <br />
             As a team player, I have effective leadership skills and exceptional communication and problem-solving capabilities
                 <br />
                  I continue to follow the latest emerging technologies as a part of my personal development.
                  In particular, I enjoy creating new digital solutions that facilitate achievement of business objectives.          </spane>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 120 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img src={react} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={vite} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={sql} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={next} alt="" />
          </div>
        
          <div className="w-secCircle">
            <img src={mongodb} alt="" height={50} />
          </div>
          <div className="w-secCircle">
            <img src={prisma} alt="" /> 
          </div>
        
        
          <div className="w-secCircle">
            <img src={nodejs} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={express} alt="" />
          </div>
        
        
          <div className="w-secCircle">
            <img src={firebase} alt="" />
          </div>
        
          <div className="w-secCircle">
            <img src={javascript} alt="" /> 
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
